/* eslint-disable no-param-reassign */
import PropTypes from "prop-types";
import { extractData } from "../utils";

const SelectContainer = ({ children, ...componentProps }) => {
  const Component = componentProps.selectProps?.custom?.SelectContainer;

  if (!Component) {
    return null;
  }

  return (
    <Component componentProps={componentProps} data={extractData(componentProps)}>
      {children}
    </Component>
  );
};

SelectContainer.propTypes = {
  selectProps: PropTypes.shape({
    custom: PropTypes.shape({
      SelectContainer: PropTypes.func,
    }),
  }),
  children: PropTypes.node,
};

SelectContainer.defaultProps = {
  selectProps: {
    custom: {
      SelectContainer: null,
    },
  },
  children: null,
};

export default SelectContainer;
